import React, { useEffect, useState, useRef } from "react";
import { useHistory } from 'react-router-dom';
import Modal from "react-bootstrap/Modal";
import { useDispatch, useSelector } from "react-redux";
import api from "~/services/api";
import ApiBullets from "~/services/Bulletins/api";
import apiLapidar from '~/services/Lapidar/api';
import CloseIcon from "@material-ui/icons/Close";
import Loading from "~/components/layout/Loading";
import { formatCNPJ, capitalizeFirstLetter, checkSubString } from '~/utils/utils';
import {
  CloseIconContainer,
  ModalContent,
  Title,
  ButtonArea,
  Button,
  ButtonLink,
  BodyContent,
  Caption
} from './styles';
import { verifyRoles } from '~/utils/functions/verifyRoles';

export default function NotificationModal(props) {
  const host_name = window.location.host;
  localStorage.setItem('LoadedPopup', false);
  const history = useHistory();
  const dispatch = useDispatch();
  const npsReducer = useSelector(state => state.npsReducer);

  const notificationReducer = useSelector(
    state => state.notificationReducer,
  );

  const roles = useSelector(state => state.rolesReducer.roles);

  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [notification, setNotification] = useState(null);

  const header = {
    'Content-Type': 'application/json',
    access_token: localStorage.getItem('access_token'),
  };
  const parameters = {
    headers: header,
  };

  useEffect(() => {
    if (!notificationReducer.loadedPopup) {
      dispatch({ type: "SET_ACTIVE_POPUP", activePopup: true });
      fetch();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function getStoreSummary() {
    try {
      const header = {
        'Content-Type': 'application/json',
        access_token: localStorage.getItem("access_token"),
      };
      const parameters = {
        method: 'GET',
        headers: header,
      };
      const externalLoadIdOrStoreId = localStorage.getItem("external_load_id") ? localStorage.getItem("external_load_id") : localStorage.getItem("storeId")
      return await apiLapidar
      .get(`/store/summary?external_load_id=${externalLoadIdOrStoreId}`, parameters)
        .then((res) => {
          localStorage.setItem('category', res.data.rating);
          return res.data.rating;
        })
        .catch((err) => {
          console.err('Error in load summary data - Popup', err)
          return false
        })
    } catch (error) {
      console.warn("Exceção in load summary - Popup", error);
      return false
    }
  }

  async function loadDataMe() {
    try {
    const header = {
      'Content-Type': 'application/json',
      access_token: localStorage.getItem('access_token'),
    };
    const parameters = {
      method: 'GET',
      headers: header,
    };
    return await api
      .get('residential/store/v1/stores/me', parameters)
      .then(res => {
        localStorage.setItem('segment', res.data.resaleSegmentation);
        localStorage.setItem('core', res.data.core);
        localStorage.setItem('market', res.data.market);
        localStorage.setItem('microMarket', res.data.microMarket);
        localStorage.setItem('branch', res.data.branch);
        localStorage.setItem('document', res.data.document);
        localStorage.setItem('state', res.data.address.stateAbbreviation);
        return res.data
      })
      .catch((err) => {
        console.err('Error in load store me - portal', err)
        return false;
      })

    } catch (error) {
      console.warn("Except in load store me - Portal", error);
      return false;
    }
  }

  async function fetchTracking(payload) {
    try {
      await api
      .put(
        '/customer-relationship/sitel/v1/calls',
        payload,
        parameters
      )
      .then(res => {
      })
      .catch(err => {
        console.log("Error tracking call - popup.", err);
      });
    } catch (error) {
      console.warn("Exceção in tracking - Popup.", error);
      return false
    }
  }

  async function fetchTrackingRead(id) {
    let document = localStorage.getItem('storeDocument');
    if (document && document != 'undefined'){
      document = formatCNPJ(document);
    } else {
      document = formatCNPJ(localStorage.getItem('document'));
    }

    try {
      await api
      .put(
        '/customer-relationship/sitel/v1/reads',
        {
          bulletinsid: id,
          cnpj: document
        },
        parameters
      )
      .then(res => {
      })
      .catch(err => {
        console.log("Error tracking read - details.", err);
      });
    } catch (error) {
      console.warn("Exceção in read - details.", error);
      return false
    }
  }

  async function getPayload() {
    const payload = {
      segment: '',
      market: '',
      nucleus: '',
      micro_market: '',
      lapidar: '',
      branch: '',
      state: '',
      cnpj: ''
    }
    const segment = localStorage.getItem('segment');
    const core = localStorage.getItem('core');
    const market = localStorage.getItem('market');
    const microMarket = localStorage.getItem('microMarket');
    const branch = localStorage.getItem('branch');
    const state = localStorage.getItem('state');
    const document = localStorage.getItem('storeDocument');
    if (segment && core && market && microMarket && branch && state && document){
      payload.segment = capitalizeFirstLetter(segment);
      payload.nucleus = core;
      payload.market = market;
      payload.micro_market = microMarket;
      payload.branch = branch;
      payload.state = state;
      payload.cnpj = formatCNPJ(document);
    } else {
      const responseStore = await loadDataMe();
      if (responseStore){
        payload.segment = capitalizeFirstLetter(responseStore.resaleSegmentation);
        payload.nucleus = responseStore.core;
        payload.market = responseStore.market;
        payload.micro_market = responseStore.microMarket;
        payload.branch = responseStore.branch;
        payload.state = responseStore.address.stateAbbreviation;
        payload.cnpj = formatCNPJ(responseStore.document);
      }
    }

    const summary = await getStoreSummary();
    if (summary) {
      payload.lapidar = capitalizeFirstLetter(summary);
    } else {
      payload.lapidar = "Não inscrita";
    }

    return  payload;
  }

  async function fetch() {
    let dataFetched = [];
    try {
      const payload = await getPayload();

      await api
      .post(
        '/customer-relationship/sitel/v1/popups',
        {
          filters: [
            payload
          ]
        },
        parameters
      )
      .then(async res => {
        if (res.data.data.length) {
          const notificationsFiltered = filterNotification(res.data.data);
          const notificationsOrdered = orderingNotifications(
            dataFetched,
            notificationsFiltered
          );
          dataFetched = removeDuplicated(notificationsOrdered);

          const notification = verifyNotification(res.data.data);
          if (notification) {
            if (checkModals()) {
              setNotification(notification);
              dispatch({ type: "SET_ACTIVE_POPUP", activePopup: true });
              dispatch({ type: "SET_ACTIVE_LOADED_POPUP", loadedPopup: true });
              setTimeout(() => {
                setShowModal(true);
              }, 4000);
              await fetchTracking(
                {
                  bulletinsid: notification.id,
                  cnpj: payload.cnpj
                }
              )
              if (!notification.hiperlinks && !notification.content) {
                fetchTrackingRead(notification.id);
              }
            }
          } else {
            dispatch({ type: "SET_ACTIVE_POPUP", activePopup: false });
            dispatch({ type: "SET_ACTIVE_LOADED_POPUP", loadedPopup: true });
          }
        } else {
          dispatch({ type: "SET_ACTIVE_POPUP", activePopup: false });
          dispatch({ type: "SET_ACTIVE_LOADED_POPUP", loadedPopup: true });
        }
      })
      .catch(err => {
        dispatch({ type: "SET_ACTIVE_POPUP", activePopup: false });
        dispatch({ type: "SET_ACTIVE_LOADED_POPUP", loadedPopup: true });
        console.log("Error get popup - page popup", err);
      });

      await api
      .post(
        '/customer-relationship/sitel/v1/pushes',
        {
          filters: [
            payload
          ]
        },
        parameters
      )
      .then(async res => {
        if (res.data.data.length) {
          const notificationsFiltered = filterNotification(res.data.data);
          const notificationsOrdered = orderingNotifications(
            dataFetched,
            notificationsFiltered
          );
          dataFetched = removeDuplicated(notificationsOrdered);
        }
      })
      .catch(err => {
        console.log("Error get data in push portal", err);
      });

      await api
      .post(
        '/customer-relationship/sitel/v1/banners',
        {
          filters: [
            payload
          ]
        },
        parameters
      )
      .then(async res => {
        if (res.data.data.length) {
          const notificationsFiltered = filterNotification(res.data.data);
          const notificationsOrdered = orderingNotifications(
            dataFetched,
            notificationsFiltered
          );
          dataFetched = removeDuplicated(notificationsOrdered);
        }
      })
      .catch(err => {
        console.log("Error get banner in page portal", err);
      });

      dispatch({ type: "SET_NOTIFICATIONS", notifications: dataFetched });

    } catch (error) {
      dispatch({ type: "SET_ACTIVE_POPUP", activePopup: false });
      dispatch({ type: "SET_ACTIVE_LOADED_POPUP", loadedPopup: true });
      console.warn("Exception in get data - portal page", error);
      return false
    }
  }

  function checkModals() {
    if (hasTrainingAndTerms()) {
      return true;
    }
    return false;
  }

  function hasNPS() {
    var element =  document.getElementById('script-indecx');
    if (typeof(element) != 'undefined' && element != null) {
      return true
    }
    return false
  }

  function hasAceptedTermsLGPDNps() {
    hasNPS()
    const privacyPolicy = localStorage.getItem('privacyPolicyFirst');
    const lgpd = localStorage.getItem('lgpd');
    if (privacyPolicy === 'true' && lgpd === 'true') {
      return true
    }
    return false;
  }

  function hasRolesTraining() {
    const competitiveCompliance = localStorage.getItem('competitiveCompliance');
    if (competitiveCompliance === 'true') return true;
    if (!verifyRoles(roles, 'TREINAMENTOS')) return true;
    return false;
  }

  function hasTrainingAndTerms() {
    if (hasAceptedTermsLGPDNps() && hasRolesTraining() && !npsReducer.open) {
      return true;
    }
    return false;
  }

  const verifyDateValid = (value) => {
    var todaysDate = new Date();

    if (!value.start_date && !value.end_date) return true;
    if (!value.start_date && value.end_date) {
      if (new Date(value.end_date) >= todaysDate) return true;
      return false;
    }
    if (value.start_date && !value.end_date) {
      if (new Date(value.start_date) <= todaysDate) return true;
      return false;
    }
    if (new Date(value.start_date) <= todaysDate && new Date(value.end_date) >= todaysDate) {
      return true;
    }
    return false;
  }

  function verifyNotification(data) {
    if (data.length > 0) {
      const items = data.filter((item) => item.status === 'published');
      const itemsDateValid = items.filter((item) => verifyDateValid(item));
      const notRead = itemsDateValid.filter((item) => item.number_of_read === null || parseInt(item.number_of_read) === 0);
      const recent = notRead.sort((a, b) => new Date(a.date_published) - new Date(b.date_published));
      if (recent.length === 0) return null;
      return recent.at(-1);
    }
    return null;
  }

  function filterNotification(data) {
    if (data.length > 0) {
      const items = data.filter((item) => item.status === 'published');
      return items;
    }
    return [];
  }

  function orderingNotifications(old, data) {
    const newData = old.concat(data)
    const ordered = newData.sort((a, b) => new Date(a.date_published) - new Date(b.date_published));
    return ordered;
  }

  function removeDuplicated(data) {
    var reduced = [];

    data.forEach((item) => {
        var duplicated  = reduced.findIndex(redItem => {
            return item.id == redItem.id;
        }) > -1;

        if(!duplicated) {
            reduced.push(item);
        }
    });
    return reduced;
  }

  function onClosePopup() {
    setShowModal(false);
    dispatch({ type: "SET_ACTIVE_POPUP", activePopup: false });
    return true;
  }

  return (
    <>
      <Modal
        show={showModal}
        onHide={() => notification?.mandatory === 0 && onClosePopup() }
        centered
        className="notification-modal"
        size="lg"
        style={{width: '100vw', margin: 0, padding: 0  }}
      >
        {notification?.mandatory === 0 && (
          <CloseIconContainer>
            <CloseIcon onClick={() => notification?.mandatory === 0 && onClosePopup()} />
          </CloseIconContainer>
        )}
        <Modal.Body>
        {
          loading ? <Loading /> : (
            <>
              <ModalContent>
                <Title>
                  <span>{notification?.title && notification.title}</span>
                </Title>
                <Caption>
                  {notification?.caption && notification.caption}
                </Caption>
                {notification?.hiperlinks && (
                    <ButtonArea>
                      <Button
                        onClick={() => {
                          onClosePopup();
                          fetchTrackingRead(notification.id);
                          window.open(
                            notification.hiperlinks,
                            checkSubString(notification.hiperlinks, host_name) ? "_self" : "_blank"
                          );
                        }}
                      >
                        Saiba mais
                      </Button>
                    </ButtonArea>
                  )}
                  {!notification?.hiperlinks && notification?.content && (
                    <ButtonArea>
                      <Button
                        onClick={() => {
                          onClosePopup();
                          history.push(`/segmented-comunication-details?id=${notification.id}`)
                        }}
                      >
                        Saiba mais
                      </Button>
                    </ButtonArea>
                  )}
              </ModalContent>
            </>
          )
        }
        </Modal.Body>
      </Modal>
    </>
  );
}
